import { render, staticRenderFns } from "./rIaPensando.vue?vue&type=template&id=022f8c04&scoped=true"
import script from "./rIaPensando.vue?vue&type=script&lang=js"
export * from "./rIaPensando.vue?vue&type=script&lang=js"
import style0 from "./rIaPensando.vue?vue&type=style&index=0&id=022f8c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f8c04",
  null
  
)

export default component.exports